import Api from './Api'

class RecTableService {
    get = () => {
        return Api().get(`recommendation-table`)
    }
    put = newData => {
        return Api().put('recommendation-table', {
            id: newData.id,
            index: newData.index,
            type: newData.type,
            et_text: newData.locale.et.text,
            et_disclaimer: newData.locale.et.disclaimer,
            et_info_label: newData.locale.et.info_label,
            en_text: newData.locale.en.text,
            en_disclaimer: newData.locale.en.disclaimer,
            en_info_label: newData.locale.en.info_label,
            fi_text: newData.locale.fi.text,
            fi_disclaimer: newData.locale.fi.disclaimer,
            fi_info_label: newData.locale.fi.info_label,
            lt_text: newData.locale.lt.text,
            lt_disclaimer: newData.locale.lt.disclaimer,
            lt_info_label: newData.locale.lt.info_label,
            graphs: newData.graphs,
        })
    }
    delete = id => {
        return Api().delete(`recommendation-table`, {
            params: { id },
        })
    }
    createRecommendation = newRec => {
        newRec = {
            index: newRec.index,
            et_text: newRec.etText,
            et_disclaimer: newRec.etDisclaimer,
            et_info_label: newRec.etInfoLabel,
            type: newRec.type,
        }
        return Api().post('recommendation-table', newRec)
    }
    downloadRecommendationsCSV() {
        return Api().get(`/recommendation-table/download`)
    }
}

export default new RecTableService()
